import { render, staticRenderFns } from "./index.vue?vue&type=template&id=6707deaa&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./styles.less?vue&type=style&index=0&id=6707deaa&prod&lang=less&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6707deaa",
  null
  
)

export default component.exports